import React from "react";
import Accordion from "../../UI/Accordion";
import Button from "~/shared/ui/Fields/Button";
import IconAutoFill from "~/components/Icons/autoFill";
import DynamicFormField from "../../UI/DynamicFormField";
import { addressFields } from "../helper";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import GeoField from "../GeoField";
import s from "../Address.less";
import { usePermissions } from "~/shared/context/PermissionContext";
// import { usePermissions } from "~/shared/context/PermissionContext";

const AdditionalAddress = ({ isRu, autoFillAddress, allDisabled }) => {
  const { t } = useTranslation();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  return (
    <>
      <div className={s.border}>
        <Accordion title="Дополнительная информация по адресам">
          <div className={s.infoWrapper}>
            <div className={s.infoLeft}>
              <div className={s.wrapperInfoTitle}>
                <div className={s.blockTitle}>
                  <div className={s.title}>Реестр юридический адрес:</div>
                </div>
                <DynamicFormField
                  name="legalAddressreestrLegalAddress"
                  label={t("dealers.reestrAddress")}
                  type="textarea"
                  customClassName={s.noneLabel}
                  className={s.bigInput}
                  disabled={true || allDisabled}
                />
              </div>
              <div className={s.wrapperInfoTitle}>
                <div className={s.blockTitle}>
                  <div className={s.title}>Юридический адрес:</div>
                  {hasPermission("dealer.updateAddress.legal") && (
                    <Button
                      txtBtn={t("dealers.autoFill")}
                      onClick={() => autoFillAddress("legalAddress")}
                      customClassName={s.autoFillButton}
                    >
                      <IconAutoFill />
                    </Button>
                  )}
                </div>
                <DynamicFormField
                  name="legalAddressfullAddress"
                  label={t("dealers.fullAddress")}
                  type="textarea"
                  customClassName={s.noneLabel}
                  className={s.bigInput}
                  disabled={true || allDisabled}
                />
              </div>
              <DynamicFormField
                name="legalAddressindex"
                label={t("dealers.index")}
                type="text"
                className={clsx(s.itemIndex)}
                disabled={true || allDisabled}
              />
              {Object.entries(addressFields).map(
                ([field, settings]) => (
                  <GeoField
                    key={`legalAddress${field}`}
                    prefix="legalAddress"
                    field={field}
                    isRu={isRu}
                    allDisabled={
                      !(
                        allDisabled ||
                        hasPermission("dealer.updateAddress.legal")
                      )
                    }
                    {...settings}
                  />
                )
              )}

              <DynamicFormField
                name="legalAddressoffice"
                label={t("dealers.office")}
                disabled={
                  !(
                      allDisabled ||
                      hasPermission("dealer.updateAddress.legal")
                  )
                }
                type="text"
                className={clsx(s.itemIndex)}
              />
            </div>
            <div className={s.infoRight}>
              <div className={s.wrapperInfoTitle}>
                <div className={s.blockTitle}>
                  <div className={s.title}>Реестр почтовый адрес:</div>
                </div>
                <DynamicFormField
                  name="postAddressreestrPostAddress"
                  label={t("dealers.reestrAddress")}
                  type="textarea"
                  customClassName={s.noneLabel}
                  className={s.bigInput}
                  disabled={true || allDisabled}
                />
              </div>
              <div className={s.wrapperInfoTitle}>
                <div className={s.blockTitle}>
                  <div className={s.title}>Почтовый адрес:</div>
                  {hasPermission("dealer.updateAddress.post") && (
                    <Button
                      txtBtn={t("dealers.autoFill")}
                      onClick={() => autoFillAddress("postAddress")}
                      customClassName={s.autoFillButton}
                    >
                      <IconAutoFill />
                    </Button>
                  )}
                </div>
                <DynamicFormField
                  name="postAddressfullAddress"
                  label={t("dealers.fullAddress")}
                  type="textarea"
                  customClassName={s.noneLabel}
                  className={s.bigInput}
                  disabled={true || allDisabled}
                />
              </div>
              <DynamicFormField
                name="postAddressindex"
                label={t("dealers.index")}
                type="text"
                className={clsx(s.itemIndex)}
                disabled={true || allDisabled}
              />
              {Object.entries(addressFields).map(
                ([field, settings]) => (
                  <GeoField
                    key={`postAddress${field}`}
                    prefix="postAddress"
                    field={field}
                    isRu={isRu}
                    allDisabled={
                      !(
                        allDisabled ||
                        hasPermission("dealer.updateAddress.post")
                      )
                    }
                    {...settings}
                  />
                )
              )}
              <DynamicFormField
                name="postAddressoffice"
                label={t("dealers.office")}
                type="text"
                disabled={
                  !(
                      allDisabled ||
                      hasPermission("dealer.updateAddress.post")
                  )
                }
                className={clsx(s.itemIndex)}
              />
            </div>
          </div>
        </Accordion>
      </div>{" "}
    </>
  );
};

export default AdditionalAddress;
